import React from "react";
import { useNavigate } from "react-router";
import CustomButton from "../../../components/form/CustomButton";

export const Columns = (openModalAdd, setModalConfirm, modalConfirm, modalFiles, setModalFiles, completeFinishLoad, loadinStatus) => {
    const navigate = useNavigate();


    let columns = [
        {
            id: 'id',
            name: 'FOLIO',
            selector: row => row.id
        },
        {
            id: 'operator',
            name: 'OPERATOR',
            selector: row => `${row.operator?.first_name} ${row.operator?.last_name}`
        },
        {
            id: 'trucksTrailers',
            name: 'TRUCKS & TRAILERS',
            selector: row => `${row.truck?.number || 'not selected'} / ${row.trailer?.number || 'not selected'}`
        },
        {
            id: 'description',
            name: 'DESCRIPTION',
            selector: row => row.description
        },
        {
            id: 'created_date',
            name: 'CREATE DATE',
            selector: row => row.created_at
        },
        {
            id: 'status',
            name: 'STATUS',
            selector: row => row.status?.name
        },
        {
            id: 'action',
            name: '',
            selector: row => (
                <div className="flex flex-col space-y-2">
                    {/* Fila superior - imprimir y enviar */}
                    <div className="flex items-center space-x-2">
                        <button className={`flex items-center justify-center px-4 py-2 ${!row.can?.delete ? '' : 'hover:bg-gray-100'}`}
                            disabled={!row.can?.delete}>
                            <i className={`fas fa-trash ${!row.can?.delete ? 'opacity-50' : 'text-red-500'}`}></i>
                        </button>
                    </div>
                </div>
            ),
        },

    ];
    return columns;
}
